import _                                 from 'underscore';
import { FormikState, useFormikContext } from 'formik';
import { SystemEvent }                   from '../types';
import { getPaths }                      from '../util';


interface UseCustomFormikHelpersHook {

    includesErrorsIn( formik: FormikState<unknown>, ...fieldNames: string[] ): boolean,
}

interface UseCustomFormikContextHelpersHook {

    validateSingleField( name: string, value: any ): void,

    handleSingletonChange( name: string, e: SystemEvent ): void,

    handleSingletonBlur( name: string, e: SystemEvent ): void,
}

function useCustomFormikHelpers(): UseCustomFormikHelpersHook{

    const includesErrorsIn: UseCustomFormikHelpersHook['includesErrorsIn'] = ( formik, ...fieldNames ) => {

        try{

            if( fieldNames && fieldNames.length ){

                let allKeys = getPaths( formik.errors, '$', '.' ).map( path => path.replace( '$.', '' ) )

                // any field name string matched in the two arrays?
                const fieldNameMatched = _.intersection( allKeys, fieldNames ).length > 0;

                // iterate through all keys
                const fieldNameContainedInPath = _.compact( allKeys.map( ( key: string ) => {

                    // any field name string contained in the key (eg: is "complexFieldname" within "complexFieldname[0].someAttr" )?
                    const searchHits = _.compact( fieldNames.map( fieldName => ( key.search( fieldName ) !== -1 ) ) );

                    return ( searchHits.length > 0 );

                } ) ).length > 0;

                return fieldNameMatched || fieldNameContainedInPath;
            }

        } catch( e ) {

        }

        return false;
    }

    return {
        includesErrorsIn
    }
}

function useCustomFormikContextHelpers(): UseCustomFormikContextHelpersHook{

    let formikContext = useFormikContext();

    const validateSingleField = ( name: string, value: any ) => {

        const error = formikContext.validate( { [ name ]: value } );

        formikContext.setFieldError( name, error[ name ] ); // set / clear error message
    };

    const handleSingletonChange = ( name: string, e: SystemEvent ) => {

        formikContext.setFieldValue( name, e.target.value );

        // validate local field only
        validateSingleField( name, e.target.value );
    };

    const handleSingletonBlur = ( name: string, e: SystemEvent ) => {

        formikContext.setFieldTouched( name, true );

        // validate local field only
        validateSingleField( name, e.target.value );
    };

    return {
        validateSingleField,
        handleSingletonChange,
        handleSingletonBlur,
    }
}

export {
    useCustomFormikHelpers,
    useCustomFormikContextHelpers,
};
